import React from 'react';
import { MDBRow, MDBBtn, MDBIcon } from 'mdbreact';

// A paleta vive em styles/cores-sobrias.css (#184). Referenciar a variável, e
// não copiar o hex, evita a paleta mista que a auditoria de 05/08 encontrou.
const COR_DESTRUTIVA = 'var(--sig-destrutiva)';
const COR_CONSTRUTIVA = 'var(--sig-construtiva)';

// Listagem de gerências da tela Gerência × Lotação (#205).
//
// Ela é o seletor da tela: clicar na linha escolhe a gerência cujas lotações
// aparecem abaixo. Substituiu o react-select, que mostrava só o nome — e o que
// a tela precisa exibir é justamente a estrutura FORMAL ao lado da LÓGICA: elas
// divergem em 3 das 18 gerências (CICC 3.1.7/3.1, Volante 3.1.6/3.1) e ninguém
// enxergava isso em lugar nenhum do sistema.
//
// Sem coluna de status: o rótulo do botão já diz o estado, em texto — não é
// informação transmitida só por cor.
export default function TabelaGerencias({
  gerencias,
  selecionada,
  onSelecionar,
  onAlternarAtivo,
  bloqueios,
}) {
  if (gerencias.length === 0) {
    return (
      <MDBRow
        style={{ borderRadius: '5px' }}
        className="p-3 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 bg-white justify-content-center"
      >
        <span className="grey-text">Nenhuma gerência no seu escopo.</span>
      </MDBRow>
    );
  }

  return (
    <>
      <MDBRow
        between
        style={{ borderRadius: '5px' }}
        className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center grey darken-1 d-none d-md-flex"
      >
        <div className="col-md-3 font-weight-bold text-white">Gerência</div>
        <div className="col-md-1 font-weight-bold text-white">Sigla</div>
        <div className="col-md-2 font-weight-bold text-white">Formal</div>
        <div className="col-md-2 font-weight-bold text-white">Lógica</div>
        {/* A contagem é da ÁRVORE inteira (mesmo texto do bloqueio de
            inativação: "nesta gerência ou abaixo dela") — a SECC aparece com
            282 tendo 0 lotados direto nela. Rótulo curto de propósito: é
            cabeçalho de tabela com seis colunas (fix final, #205). */}
        <div className="col-md-2 font-weight-bold text-white">
          Pessoas (total)
        </div>
        <div className="col-md-2 font-weight-bold text-white text-right" />
      </MDBRow>

      {gerencias.map(g => {
        const escolhida = selecionada && selecionada.value === g.value;
        return (
          <MDBRow
            key={g.value}
            between
            role="button"
            tabIndex={0}
            aria-pressed={escolhida}
            onClick={() => onSelecionar(g)}
            onKeyDown={evento => {
              // Devolve a operação por teclado que a linha tirou do
              // <Select> que ela substituiu (fix final, #205): Enter/Espaço
              // selecionam, igual ao clique. `target !== currentTarget`
              // ignora keydown que veio de dentro do botão de
              // Inativar/Reativar (ele já tem Enter/Espaço nativos do
              // <button>) — sem isso, ativar o botão pelo teclado também
              // selecionaria a linha.
              if (evento.target !== evento.currentTarget) return;
              if (evento.key === 'Enter' || evento.key === ' ') {
                evento.preventDefault();
                onSelecionar(g);
              }
            }}
            style={{
              borderRadius: '5px',
              cursor: 'pointer',
              // a selecionada ganha uma barra à esquerda; a inativa fica em
              // cinza mais fraco, sem depender só de cor para se distinguir
              borderLeft: escolhida
                ? '4px solid #4285f4'
                : '4px solid transparent',
              opacity: g.ativo ? 1 : 0.65,
            }}
            className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center bg-white"
          >
            <div className="col-12 col-md-3 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Gerência:</span>
              {g.label}
            </div>
            <div className="col-12 col-md-1 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Sigla:</span>
              {g.sigla}
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Formal:</span>
              {g.formal}
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Lógica:</span>
              {g.logica}
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Pessoas:</span>
              {Number(g.pessoas || 0)}
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-center justify-content-md-end mt-2 mt-md-0">
              <MDBBtn
                size="sm"
                color="white"
                className="m-0"
                style={{
                  color: g.ativo ? COR_DESTRUTIVA : COR_CONSTRUTIVA,
                  border: `1px solid ${
                    g.ativo ? COR_DESTRUTIVA : COR_CONSTRUTIVA
                  }`,
                  boxShadow: 'none',
                }}
                onClick={evento => {
                  // sem isto, o clique no botão também seleciona a linha
                  evento.stopPropagation();
                  onAlternarAtivo(g);
                }}
              >
                <MDBIcon
                  far
                  icon={g.ativo ? 'thumbs-down' : 'thumbs-up'}
                  className="mr-2"
                />
                {g.ativo ? 'Inativar' : 'Reativar'}
              </MDBBtn>
            </div>

            {bloqueios[g.value] && (
              <div className="col-12 mt-2" style={{ color: COR_DESTRUTIVA }}>
                <MDBIcon icon="exclamation-triangle" className="mr-2" />
                {`${bloqueios[g.value]} pessoa(s) ainda estão nesta gerência ou abaixo dela — mova-as antes.`}
              </div>
            )}
          </MDBRow>
        );
      })}
    </>
  );
}
